module.exports = __webpack_public_path__ + "img/La Jolla beach depth2.29400ce0.jpg";